import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { VoucherI18n_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	voucherID: string;
	lang: LangCode;
};

export const useVoucherI18nEditQuery = ({ hotelID, voucherID, lang }: Props) => {
	const { data } = useCustomSuspenseQuery(VoucherI18n_EditPage_Query, {
		variables: { hotelID, voucherID, lang },
	});

	return data;
};
